// Owner: library (plan §3.1). `/pages` is the Library with the type filter "Pages"; an old folder link
// (`?folder=`) opens that folder, which became a parent page with the same id (§7.6).
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/pages/')({
  validateSearch: (search: Record<string, unknown>): { folder?: string; templates?: boolean } => ({
    folder:
      typeof search.folder === 'string' && /^[a-f0-9-]{36}$/i.test(search.folder) ? search.folder : undefined,
    templates: search.templates === true || search.templates === 'true' ? true : undefined,
  }),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/library',
      search: search.templates
        ? { space: 'templates' }
        : search.folder
          ? { parent: search.folder }
          : { type: 'page' },
      replace: true,
    });
  },
});
